import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Label, Popup } from 'semantic-ui-react';
import TagEditor from '../tag-editor';

const InfluencerTag = ({
  id,
  attributes: { value },
  onSave,
  onDelete,
}) => (
  <Label
    basic
    size="big"
  >
    {value}
    <Popup
      content={<TagEditor value={value} id={id} onSave={onSave} onDelete={onDelete} />}
      on="click"
      position="top center"
      trigger={<Icon name="settings" />}
    />

  </Label>
);

InfluencerTag.propTypes = {
  id: PropTypes.string.isRequired,
  attributes: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default InfluencerTag;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-tag/index.js
 **/